<app-data-table mainTitle="Moedas"
                singleTitle="Moeda"
                routerPath="/siscoserv/moeda"
                entityPath="/tbcodmoeda"
                gender="feminine"
                [entity]="tbCodMoeda"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table>
